'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'gauge-max';
var width = 512;
var height = 512;
var aliases = ["tachometer-alt-fastest"];
var unicode = 'f626';
var svgPathData = ['M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-35.3 28.7-64 64-64 14.5 0 27.8 4.8 38.5 12.9l109.1-65.5c11.4-6.8 26.1-3.1 32.9 8.2s3.1 26.1-8.2 32.9L319.2 342.1c.5 3.2 .8 6.6 .8 9.9 0 35.3-28.7 64-64 64s-64-28.7-64-64zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm112 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M403.7 235.4c11.4-6.8 26.1-3.1 32.9 8.2s3.1 26.1-8.2 32.9L319.2 342.1c.5 3.2 .8 6.6 .8 9.9 0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c14.5 0 27.8 4.8 38.5 12.9l109.1-65.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGaugeMax = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;